'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { useState } from 'react';
import Link from 'next/link';
import { Col, Container, Dropdown, DropdownMenu, DropdownToggle, Row } from 'reactstrap';
import { MdKeyboardArrowDown, MdLanguage } from 'react-icons/md';
import LinkedIn from 'shared/components/svg/LinkedIn';
import capitalizeFirstLetter from 'shared/utils/capitalizeFirstLetter';
import { Dictionaries } from 'shared/i18n/i18n-config';
import { getI18nUtils } from 'shared/i18n/i18n-utils';
import { usePathname } from 'next/navigation';
import { defaultLocales } from '../../config';
import splitLanguageFromPath from '../../utils/splitLanguageFromPath';
import { menu, legals, deviantLocales } from './menuConfig';
import Image from 'next/image';

export default function Footer({ dictionary }: { dictionary: Dictionaries }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const { locale, pathname } = splitLanguageFromPath(usePathname());
  const { formatMessage } = getI18nUtils(dictionary);

  const availableLocales = deviantLocales[pathname] ?? defaultLocales.map((l) => ({ locale: l, pathname }));

  return (
    <footer id="footer" className="bg-blue">
      <Container className="pageFooterBottomContainer pt-5 text-center text-lg-start">
        {/** TOP: Language & socials */}
        <Row className="d-flex align-items-center mb-2 mb-md-5">
          <Col
            xs="12"
            lg="3"
            className="d-flex justify-content-center justify-content-lg-start align-items-center flex-lg-row flex-column mb-2 mb-lg-0"
          >
            <Link className="me-lg-4 my-2" href={`/${locale}/`}>
              <Image src="/logos/logo_white.svg" alt="logo S&you footer" id="logo" width={140} height={100} />
            </Link>
            <h2 className="text-uppercase pt-2">
              Specialist <br /> Recruitment
            </h2>
          </Col>
          <Col xs="5" lg="4" xl="5" className="ms-auto">
            <hr className="footer-divider d-none d-lg-block" />
          </Col>
          <Col xs="12" lg={{ size: 1, order: 4 }} className="d-flex justify-content-center align-items-center mb-2 mb-lg-0">
            <div>
              <a href="https://www.linkedin.com/company/s-and-you-belgium/" target="_blank" rel="noreferrer noopener">
                <LinkedIn />
              </a>
            </div>
          </Col>
          <Col xs="12" lg={{ size: 1, order: 3 }}>
            <hr className="footer-divider" />
          </Col>
          <Col xs="12" lg={{ size: 2, order: 2 }} className="footer-language d-flex justify-content-center my-4">
            <Dropdown
              toggle={() => setDropdownOpen(!dropdownOpen)}
              isOpen={dropdownOpen}
              className="d-flex justify-content-center"
            >
              <DropdownToggle className="d-flex align-items-center justify-content-center">
                <MdLanguage size={24} />
                <div className="d-inline mx-2">{capitalizeFirstLetter(formatMessage({ id: `${locale}` }))}</div>
                <MdKeyboardArrowDown
                  className="transition-all"
                  style={dropdownOpen ? { transform: 'rotateX(180deg)' } : undefined}
                  size={24}
                />
              </DropdownToggle>
              <DropdownMenu className="dropmenu-fade-in-top" end>
                {availableLocales
                  .filter((al) => al.locale !== locale)
                  .map((l) => (
                    <Link
                      className="py-2 dropdown-item d-block text-capitalize"
                      href={`/${l.locale}${l.pathname}`}
                      locale={l.locale}
                      key={`locale_switcher_${l.locale}`}
                    >
                      {formatMessage({ id: `${l.locale}` })}
                    </Link>
                  ))}
              </DropdownMenu>
            </Dropdown>
          </Col>
        </Row>
        {/** MIDDLE: Menu */}
        <Row className="upper-row d-flex justify-content-between">
          {menu
            .filter((section) => section.footer !== -1)
            .sort((a, b) => a.footer - b.footer)
            .map((section) => (
              <Col xs="12" lg={section.name === 'international' ? '4' : '2'} key={section.name}>
                <Link href={`/${locale}${section.destination}`}>
                  <h4 className="text-capitalize text-white">{formatMessage({ id: section.name })}</h4>
                </Link>
                <ul className={section.name === 'international' ? 'international-column' : undefined}>
                  {section.subMenu
                    .filter((item) => item.footer !== -1)
                    .sort((a, b) => a.footer - b.footer)
                    .map((subMenu) => (
                      <li key={subMenu.name}>
                        {subMenu.internal ? (
                          <Link href={`/${locale}${subMenu.destination}`}>{formatMessage({ id: subMenu.name })}</Link>
                        ) : (
                          <Link href={`${subMenu.destination}`}>{formatMessage({ id: subMenu.name })}</Link>
                        )}
                      </li>
                    ))}
                </ul>
              </Col>
            ))}
        </Row>
        {/** BOTTOM: Legal */}
        <div className="position-relative my-4 w-100">
          <hr className="footer-divider" />
        </div>
        <ul
          id="footer-legals"
          className="pb-3 d-flex flex-column flex-md-row justify-content-center justify-content-lg-start flex-wrap"
        >
          {legals.map((item) => (
            <li key={item.name} className="me-3 py-1">
              {item.internal ? (
                <Link className="text-lowercase" href={`/${locale}${item.destination}`}>
                  {formatMessage({ id: item.name })}
                </Link>
              ) : (
                <Link
                  className="text-lowercase"
                  href={`${item.destination}?lang=${locale}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {formatMessage({ id: item.name })}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </Container>
    </footer>
  );
}
